module.exports = __webpack_public_path__ + "static/media/realtalk_sd_sora4d1ae9cd2fd6a3041b7abea9894bcaa3.webp";